import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import ReCAPTCHA from "react-google-recaptcha";
import { Formik } from "formik";
import ReactSVG from "react-svg";
import { useDispatch, useSelector } from "react-redux";
import { UploadField, Alert } from "~/components/elements";
import { useHistory, useLocation } from "react-router-dom";
import AlertSmall from "~/assets/img/icon/alert-small.svg";
import TrashIcon from "~/assets/img/icon/trash-icon.svg";
import EditIcon from "~/assets/img/icon/icon-edit.svg";
import QuestionIcon from "~/assets/img/icon/question-icon-blue.svg";
import { schema } from "./validation";
import { dateMask, formatDate, formatCNPJ} from "~/utils/tools";
import { Creators as purchaseActions } from "~/store/modules/promo/actions";
import * as S from "./styles";

import {
  Text,
  Title,
  Margin,
  Input,
  Button,
  ErrorMessage,
  Loading,
} from "~/components/elements";

export default function FormInvoice({
  mobile,
  openModalProduct,
  products,
  openModalQuestion,
  removeProduct
}) {
  const history = useHistory();
  const [captchaTrue, setCaptcha] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;
  const sending = useSelector((state) => state.promo.purchase.sending);
  const success = useSelector((state) => state.promo.purchase.response?.sucesso);
  const ganhou = useSelector((state) => state.promo.purchase.response?.ganhou);

  const errorMessage = useSelector((state) => state.promo.purchase.errorMessage);

  useEffect(() => {
    dispatch(purchaseActions.getProducts());
    dispatch(purchaseActions.getSellers());
  }, [dispatch]);

  useEffect(() => {
    if (success && !errorMessage) {
      history.push({
        pathname: "/cadastro-promo/sucesso",
        state: { ganhou }
      });

      dispatch(purchaseActions.resetPurchaseState());
    }
  }, [history, success, errorMessage, dispatch, ganhou]);

  const initialValues = {
    Data: "",
    Numero: "",
    Cnpj: "",
    Imagem: "",
    Fornecedor: "",
    AmbienteCompra: "1",
  };

  function formatCurrencyValue(value) {
    const formattedValue = value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

    return formattedValue;
  }

  function sumCurrencyValues(values) {
    const numericValues = values?.map((value) => {
      const numericString = value.Valor.replace("R$ ", "")
        .replace(".", "")
        .replace(",", ".");
      return parseFloat(numericString * value.Quantidade);
    });

    const sum = numericValues?.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    return sum || 0;
  }

  const getTotalValueProducts = () => {
    const totalSum = sumCurrencyValues(products);
    const sumCurrencyFormated = formatCurrencyValue(totalSum);
    return sumCurrencyFormated;
  };

  function formatPrice(price) {
    const numericString = price
      .replace("R$ ", "")
      .replace(".", "")
      .replace(",", ".");
    return parseFloat(numericString);
  }

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(false);
          const date = formatDate(values.Data);
          const newDate = new Date(date).toISOString().split("T")[0];

          const productsString = {};
          products.forEach((item, index) => {
            productsString[`Produtos[${index}][ProdutoId]`] = item.Produto.id;
            productsString[`Produtos[${index}][Valor]`] = formatPrice(
              item.Valor
            );
            productsString[`Produtos[${index}][Quantidade]`] = item.Quantidade;
          });
          // debugger;

          const payloadValues = {
            ...values,
            Url: url,
            Origin: origin,
            Data: newDate,
            Cnpj: values.Cnpj,
            Numero: values.Numero.replace(/^0+/, ""),
            Fornecedor: values.Fornecedor.label,
            ...productsString,
          };

          dispatch(purchaseActions.sendRegisterPurchase(payloadValues));
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isValid,
          dirty,
          setFieldTouched,
        }) => (
          <S.FormLimiter onSubmit={handleSubmit}>
            <Margin mb={3}>
              <Title level="6" levelDesktop="6">
                <strong>Dados do seu cupom fiscal</strong>
              </Title>
            </Margin>

            <Grid item xs={12} md={12}>
              <Margin mb={mobile ? 3 : 4}>
                <S.InputHolder>
                  <Input
                    mask={dateMask()}
                    label="Data da compra"
                    placeholder="00/00/0000"
                    htmlFor="purchaseFieldFormInvoice"
                    name="Data"
                    value={values.Data}
                    onChange={handleChange}
                    // icon={Calendar}
                    onBlur={handleBlur}
                    errors={errors.Data && touched.Data && errors.Data}
                    valid={!errors.Data && touched.Data && !errors.Data}
                  />
                </S.InputHolder>
              </Margin>
            </Grid>
            <Grid item xs={12} md={12}>
              <S.InputHolder>
                <Margin mb={mobile ? 3 : 4} mr={0}>
                  <Input
                    label="Número do cupom fiscal"
                    placeholder="000000000000"
                    htmlFor="couponFieldFormInvoice"
                    name="Numero"
                    maxLength="12"
                    value={values.Numero?.replace(/\D/g, "")}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    errors={errors.Numero && touched.Numero && errors.Numero}
                    valid={!errors.Numero && touched.Numero && !errors.Numero}
                  />
                  <S.FieldCouponWarning>
                    <ReactSVG src={AlertSmall} />
                    <Text level="3">
                      Importante: guarde sua nota fiscal.
                    </Text>
                  </S.FieldCouponWarning>
                </Margin>

              <Margin mb={mobile ? 3 : 4} mr={0}>
                <Input
                    label="CNPJ"
                    placeholder="XX.XXX.XXX/XXXX-XX"
                    htmlFor="cnpj"
                    name="Cnpj"
                    value={formatCNPJ(values.Cnpj)}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    errors={errors.Cnpj && touched.Cnpj && errors.Cnpj}
                    valid={!errors.Cnpj && touched.Cnpj && !errors.Cnpj}
                  />
                </Margin>
                <S.QuestionIcon>
                  <ReactSVG
                    src={QuestionIcon}
                    onClick={() => openModalQuestion("coupon")}
                  />
                </S.QuestionIcon>
              </S.InputHolder>
            </Grid>

            {/* <Grid item xs={12} md={12}>
              <FormControl>
                <Margin mb={2}>
                  <FormLabel component="legend">
                    <Text level="2">
                      <S.RadioStyleTitle>
                        Comprou no site ou app?
                      </S.RadioStyleTitle>
                    </Text>
                  </FormLabel>
                </Margin>
                <RadioGroup
                  aria-label="Onde Comprou"
                  name="AmbienteCompra"
                  value={values.AmbienteCompra}
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  <Margin ml={1} mb={2}>
                    <FormControlLabel
                      value="1"
                      control={
                        <Radio checkedIcon={<ReactSVG src={RadioCheck} />} />
                      }
                      label="Aplicativo"
                    />
                  </Margin>
                  <Margin ml={1} mb={3}>
                    <FormControlLabel
                      value="0"
                      control={
                        <Radio checkedIcon={<ReactSVG src={RadioCheck} />} />
                      }
                      label="Site"
                    />
                  </Margin>
                  {!!errors.AmbienteCompra && (
                    <Margin mt={1}>
                      <Message variant="error">{errors.AmbienteCompra}</Message>
                    </Margin>
                  )}
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={12}>
              <Margin mb={mobile ? 3 : 4} mr={0}>
                <Select
                  label="Em qual site ou app comprou?"
                  name="Fornecedor"
                  placeholder="Selecionar loja"
                  onChange={setFieldValue}
                  onBlur={handleBlur}
                  value={values.Fornecedor}
                  errors={touched.Fornecedor && errors.Fornecedor}
                  valid={!errors.Fornecedor}
                  options={sellers}
                  required
                  id="stateFieldFormLoja"
                />
              </Margin>
            </Grid>

            <Grid item xs={12} md={12}>
              <S.InputHolder>
                <Margin mb={mobile ? 3 : 4}>
                  <Input
                    label="CNPJ da loja"
                    placeholder="XX.XXX.XXX/XXXX-XX"
                    htmlFor="couponFieldFormInvoice"
                    name="Cnpj"
                    value={formatCNPJ(values.Cnpj)}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    errors={errors.Cnpj && touched.Cnpj && errors.Cnpj}
                    valid={!errors.Cnpj && touched.Cnpj && !errors.Cnpj}
                  />
                </Margin>
                <S.QuestionIcon>
                  <ReactSVG
                    src={QuestionIcon}
                    onClick={() => openModalQuestion("cnpj")}
                  />
                </S.QuestionIcon>
              </S.InputHolder>
            </Grid> */}

            <Margin mb={5}>
              <UploadField
                name="Imagem"
                errors={errors.Imagem && touched.Imagem && errors.Imagem}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
              />
            </Margin>

            <Margin mb={5}>
              <Alert type="warning">
                <S.GuardeNota>
                  <strong>IMPORTANTE:</strong><br/>
                  <strong>Guarde sua nota fiscal.</strong>
                </S.GuardeNota>
              </Alert>
            </Margin>

            <Margin mb={mobile ? 3 : 2}>
              <Title level="6" levelDesktop="6">
                <strong>Produtos do seu cupom fiscal</strong>
              </Title>
            </Margin>

            <Margin mb={mobile ? 7 : 3}>
              <S.ProductsHolder>
                <Text level="2" primary>
                  Clique abaixo para adicionar os produtos participantes da promoção. Lembre-se de <strong>cadastrar todos os produtos </strong> presentes na nota fiscal.
                </Text>
              </S.ProductsHolder>

              {products.length > 0 ? (
                products.map((data, index) => {
                  return (
                    <S.Product>
                      <S.ProductTop>
                        <img
                          src={data.Produto.imagem}
                          alt={data.Produto.label}
                        />
                        <Text level={mobile ? '3' : '2'}>{data.Produto.label}</Text>
                      </S.ProductTop>
                      <S.ProductBottom>
                        <div>
                          <div>
                            <Text level="3">Preço</Text>
                            <Text level="2" as="strong">
                              {data.Valor}
                            </Text>
                          </div>
                          <div>
                            <Text level="3">Quantidade</Text>
                            <Text level="2" as="strong">
                              {data.Quantidade}x
                            </Text>
                          </div>
                          <S.EditProductBtn
                            onClick={() =>
                              openModalProduct({
                                ...data,
                                key: index,
                                open: true,
                              })
                            }
                          >
                            <ReactSVG wrapper="span" src={EditIcon} />
                            <Text as="strong" level="3">
                              EDITAR
                            </Text>
                          </S.EditProductBtn>
                          <S.RemoveProductBtn
                            onClick={() => removeProduct(index)}
                          >
                            <ReactSVG wrapper="span" src={TrashIcon} />
                            <Text as="strong" level="3">
                              REMOVER
                            </Text>
                          </S.RemoveProductBtn>
                        </div>
                      </S.ProductBottom>
                    </S.Product>
                  );
                })
              ) : (
                <S.Product>
                  <S.ProductTop>
                    <S.Skeleton />
                    <Text level={mobile ? '3' : '2'}>Produto</Text>
                  </S.ProductTop>
                  <S.ProductBottom className="fake">
                    <div>
                      <S.ProductBottomLabel>Preço</S.ProductBottomLabel>
                      <S.ProductBottomValue>R$ 00,00</S.ProductBottomValue>
                    </div>
                    <div>
                      <S.ProductBottomLabel>Quantidade</S.ProductBottomLabel>
                      <S.ProductBottomValue>00</S.ProductBottomValue>
                    </div>
                  </S.ProductBottom>
                </S.Product>
              )}
            </Margin>

            <Margin mt={2} mb={5}>
              <S.AddProductListButton
                color={sending ? "disabled" : "primary"}
                className="animation-size"
                id="addProductButtonFormInvoice"
                onClick={() =>
                  openModalProduct({
                    open: true,
                  })
                }
              >
                ADICIONAR PRODUTO
              </S.AddProductListButton>
            </Margin>
            <Margin mb={5}>
              <S.TotalProducts>
                <S.ValorTotalLabel>
                  Valor total dos itens:
                </S.ValorTotalLabel>
                <S.ValorTotal> {getTotalValueProducts()}</S.ValorTotal>
              </S.TotalProducts>
            </Margin>

            {sumCurrencyValues(products) < 50 && (
              <S.MinimumValue>
                <ReactSVG src={AlertSmall} />
                Valor mínimo em produtos participantes R$ 50,00
              </S.MinimumValue>
            )}

            <Margin mb={mobile ? 3 : 4}>
              <S.CaptchaHolder>
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                  onChange={setCaptcha}
                />
              </S.CaptchaHolder>
            </Margin>
            <S.ButtonsGrid
              container
              justifyContent="space-between"
              direction={mobile ? "column-reverse" : "row"}
            >
              <Button
                className="animation-size"
                variant="outlined"
                id="returnButtonFormInvoice"
                onClick={() =>
                  history.push({
                    pathname: "/minha-conta",
                    search: location.search,
                  })
                }
              >
                {"< Voltar"}
              </Button>

              <Button
                className="animation-size"
                color={
                  !isValid ||
                  !dirty ||
                  sending ||
                  products.length === 0 ||
                  !captchaTrue ||
                  sumCurrencyValues(products) < 50
                    ? "disabled"
                    : "primary"
                }
                type="submit"
                disabled={
                  !isValid ||
                  !dirty ||
                  sending ||
                  products.length === 0 ||
                  !captchaTrue ||
                  sumCurrencyValues(products) < 50
                }
                id="nextButtonFormInvoice"
              >
                {sending ? <Loading button /> : "AVANÇAR >"}
              </Button>
            </S.ButtonsGrid>
            {errorMessage && (
              <Margin mt={mobile ? 3 : 1}>
                <ErrorMessage>{errorMessage}</ErrorMessage>
              </Margin>
            )}
          </S.FormLimiter>
        )}
      </Formik>
    </>
  );
}
